<template>
	<vxe-pulldown ref="xDown4" transfer>
		<template v-slot>
			<vxe-input :value="value" suffix-icon="fa fa-search" @keyup="keyupEvent4" @focus="focusEvent4" style="width:100%;"
				@suffix-click="suffixClick4"></vxe-input>
		</template>
		<template v-slot:dropdown>
			<div class="my-dropdown4">
				<vxe-grid highlight-hover-row :loading="loading" :data="tableData" :columns="tableColumn4"
					:height="200" show-overflow
					@cell-click="cellClickEvent4">
				</vxe-grid>
			</div>
		</template>
	</vxe-pulldown>
</template>

<script>
	export default {
		props: {
			value: {
				type: String || Number,
				default: ''
			},
			tableData4: {
				type: Array,
				default: () => []
			},
			tableColumn4: {
				type: Array,
				default: () => []
			},
			valuename: {
				type: String,
				default: ''
			},
			filtervalue: {
				type: String,
				default: ''
			}
		},
		data: function() {
			return {
				loading: false,
				tableData: [],
				tableDataSource:[]
			};
		},
		watch:{
			tableData4(a,b){
				this.getData();
			}
		},
		mounted() {
				this.getData()
		},
		methods: {
			getData(){
				this.tableDataSource=this.tableData4.filter(row=>{
					if(this.filtervalue&&row[this.valuename]){
						return row[this.valuename].indexOf(this.filtervalue) > -1;
					}else if(!this.filtervalue){
						return true;
					}
				});
				this.tableData=this.tableDataSource;
				// console.log(this.tableDataSource,this.tableData)
				this.$forceUpdate();
			},
			keyupEvent4(e) {
				const {
					value
				} = e
				this.loading = true
				setTimeout(() => {
					this.loading = false
					if (value) {
						this.tableData = this.tableDataSource.filter(row => {
							if (row[this.valuename]) {
								return row[this.valuename].indexOf(value) > -1;
							}
						})
					} else {
						this.tableData = this.tableDataSource.slice(0)
					}
				}, 100)

			},
			focusEvent4() {
				this.$refs.xDown4.showPanel()
			},
			suffixClick4() {
				this.$refs.xDown4.togglePanel()
			},
			cellClickEvent4({
				row
			}) {
				this.value4 = row[this.valuename]
				this.$emit('click',row[this.valuename])
				this.$refs.xDown4.hidePanel();
				this.$forceUpdate();
			}
		}
	}
</script>

<style>
	/* .my-dropdown4{
		height: 200px;
		background-color: #fff;
		box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
	} */
</style>
